import { render, staticRenderFns } from "./solutionsTab5.vue?vue&type=template&id=405c6072&"
import script from "./solutionsTab5.vue?vue&type=script&lang=js&"
export * from "./solutionsTab5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports